//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 21.12.2016.
 */

(function () {

    'use strict';

    angular.module('container.widgets')
        .factory('tableColumnDurationFilterService', tableColumnDurationFilterService);

    function tableColumnDurationFilterService(sortService) {

        let service = {};

        service.filter = data => {

            let filteredItems = data.unfilteredItems.slice();

            // Filter by duration range
            if (data.durationFilterType == 'range') {
                filteredItems = filteredItems.filter(item => {
                    return item[data.columnKey] >= data.fromDuration.milliseconds && item[data.columnKey] <= data.toDuration.milliseconds;
                });
            }

            // Filter by duration string
            if (data.searchText) {
                filteredItems = filteredItems.filter(item => {
                    return item[data.columnKey].toString().indexOf(data.searchText) > -1;
                });
            }

            // Sort by direction
            if (data.column.sortDirection) {
                filteredItems = sortService.sortItemsByDuration(filteredItems, data.columnKey, data.column.sortDirection == 'asc');
            }

            data.itemsFiltered(filteredItems);
        };

        return service;
    }
})();